// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/app.additional.jsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/app.additional.jsx");
  import.meta.hot.lastModified = "1692612803100.5144";
}
// REMIX HMR END

import { Box, Card, Layout, Link, List, Page, Text, VerticalStack } from "@shopify/polaris";
export default function AdditionalPage() {
  return <Page>
      <ui-title-bar title="Additional page" />
      <Layout>
        <Layout.Section>
          <Card>
            <VerticalStack gap="3">
              <Text as="p" variant="bodyMd">
                The app template comes with an additional page which
                demonstrates how to create multiple pages within app navigation
                using{" "}
                <Link url="https://shopify.dev/docs/apps/tools/app-bridge" target="_blank">
                  App Bridge
                </Link>
                .
              </Text>
              <Text as="p" variant="bodyMd">
                To create your own page and have it show up in the app
                navigation, add a page inside <Code>app/routes</Code>, and a
                link to it in the <Code>&lt;ui-nav-menu&gt;</Code> component
                found in <Code>app/routes/app.jsx</Code>.
              </Text>
            </VerticalStack>
          </Card>
        </Layout.Section>
        <Layout.Section secondary>
          <Card>
            <VerticalStack gap="2">
              <Text as="h2" variant="headingMd">
                Resources
              </Text>
              <List spacing="extraTight">
                <List.Item>
                  <Link url="https://shopify.dev/docs/apps/design-guidelines/navigation#app-nav" target="_blank">
                    App nav best practices
                  </Link>
                </List.Item>
              </List>
            </VerticalStack>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>;
}
_c = AdditionalPage;
function Code({
  children
}) {
  return <Box as="span" padding="025" paddingInlineStart="1" paddingInlineEnd="1" background="bg-subdued" borderWidth="1" borderColor="border" borderRadius="1">
      <code>{children}</code>
    </Box>;
}
_c2 = Code;
var _c, _c2;
$RefreshReg$(_c, "AdditionalPage");
$RefreshReg$(_c2, "Code");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;